import { call, put } from 'redux-saga/effects';
import { getLastReceiptUploadStatus } from '../api';
import {
  fetchLastReceiptUploadStatusFailure,
  fetchLastReceiptUploadStatusSuccess,
} from '../actions';
import { FetchLastReceiptUploadStatusRequestAction } from '../types';
import { ApiError } from 'store/api/types';
import { checkResponse } from 'store/utils';
import { MessageData } from 'store/app/types';
import { turnMessageOn } from 'store/app/actions';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* fetchLastReceiptUploadStatusSaga(
  action: FetchLastReceiptUploadStatusRequestAction
) {
  try {
    const { organisationId } = action.payload;
    if (!organisationId) {
      yield put(fetchLastReceiptUploadStatusFailure());
      return;
    }

    const response = yield call(getLastReceiptUploadStatus, organisationId);

    const err: ApiError | null = checkResponse(response?.responseMessage);
    if (err) throw err;

    const status = response?.data;
    yield put(fetchLastReceiptUploadStatusSuccess(status));
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(fetchLastReceiptUploadStatusFailure());
  }
}

